export const CARDIF_FR = "ca_bnp_fr";
export const EA_SWITZERLAND = "ea_generic_ch";
export const SENTRYBAY = "sentrybay";
